// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, LayerInfo, VectorOrigination,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  Descriptor = require('../descriptor');

  module.exports = VectorOrigination = (function(superClass) {
    extend(VectorOrigination, superClass);

    function VectorOrigination() {
      return VectorOrigination.__super__.constructor.apply(this, arguments);
    }

    VectorOrigination.shouldParse = function(key) {
      return key === 'vogk';
    };

    VectorOrigination.prototype.parse = function() {
      this.file.seek(8, true);
      return this.data = new Descriptor(this.file).parse();
    };

    return VectorOrigination;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/vector_origination.js
// module id = 71
// module chunks = 0